// extracted by mini-css-extract-plugin
export default {"header":"ProductList_header__mUhqM","group":"ProductList_group__U0Gbh","flag":"ProductList_flag__re5cC","subheading":"ProductList_subheading__eO7qn"};